import { Grid } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  const fields = [
    {
      label: "Nome",
      name: "name",
      required: true,
      type: "text",
      localized: true,
    },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            disabled={disabled}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
